import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Partitio Single Story" mdxType="SEO" />
    <h2 {...{
      "id": "partitio-single-story-inventorless-route"
    }}>{`Partitio Single Story (Inventorless Route)`}</h2>
    <p>{`Credit to `}<a parentName="p" {...{
        "href": "https://www.twitch.tv/ytreds"
      }}>{`YTreds`}</a>{` for the initial inventorless route.`}<br parentName="p"></br>{`
`}{`Also credit to fura for running it which led to me seeing it, and all the other runners / routers of this category (and solo Partitio), whose work this was built on top of.`}</p>
    <p>{`If you want to follow along a video, `}<a parentName="p" {...{
        "href": "https://youtu.be/n4qgEImJ-b4"
      }}>{`this`}</a>{` is my PB at the time of writing these notes. Note that the run was done with an older Garnet script, which used $30000 on the fight and mugged the old man in Cape Cold for money.`}</p>
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`Start Partitio`}</p>
    <h3 {...{
      "id": "oresrush-partitio-ch1"
    }}>{`Oresrush (Partitio Ch.1)`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Fire S, Thunder S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Hire closest guy.`}</p>
    <p>{`Kill forced battle with Attack > Arrow of Fortune x2 twice.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Light S`}</strong>{`.`}</p>
    <p>{`Kill 1st battle with Attack > Arrow of Fortune x3`}</p>
    <p>{`Heal before Giff if needed`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "giff"
      }}>{`Giff`}</h4>
      <ol>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Thunder S`}</li>
        <li parentName="ol">{`Attack x4 Giff (If needed, delay and Healing Grape)`}</li>
        <li parentName="ol">{`Thunder S`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Arrow of Fortune x3`}</li>
      </ol>
      <p>{`(Might need to heal, fight isn't safe)`}</p>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Cropdale`}</strong>{`. Recruit `}<strong parentName="p">{`Agnea`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{`. Tag `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`, warp to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush"
    }}>{`Oresrush`}</h3>
    <p>{`Hire `}<strong parentName="p">{`Smooth Talker`}</strong><br parentName="p"></br>{`
`}{`Go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Lump of Silver`}</li>
        <li parentName="ul">{`Silver Ingot`}</li>
      </ul>
    </Menu>
    <p>{`Purchase `}<strong parentName="p">{`Ice M`}</strong>{` from lady in the corner.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}</p>
    <p>{`Go towards `}<strong parentName="p">{`Cape Cold`}</strong>{`, get `}<strong parentName="p">{`Osvald`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After getting `}<strong parentName="p">{`Osvald`}</strong>{`, warp `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Bottle of White Powder`}</strong>{` from lady.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Get `}<strong parentName="p">{`Castti`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Turn in `}<strong parentName="p">{`Powder Quest`}</strong>{`, buy `}<strong parentName="p">{`Wind M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage-1"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p><em parentName="p">{`Walking this whole screen is a 7% chance of a double battle.`}</em><br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Western Tropu'hopu Traverse`}</strong>{`, kill battle with `}<strong parentName="p">{`Wind M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill battle with `}<strong parentName="p">{`Ice M`}</strong>{`. Pick `}<strong parentName="p">{`Light M`}</strong>{`. Kill battle with `}<strong parentName="p">{`Light M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Collect +Hired Help`}</li>
        <li parentName="ul">{`Agnea: +Stimulate`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze/Elemental Barrage`}</li>
        <li parentName="ul">{`Castti: +Poison Axe`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Poison Axe is to cover a very rare Thurston situation.`}<br parentName="p"></br>{`
`}{`Elemental Barrage can be used for an alternate Garnet fight. Fight will be listed in the addendum.`}</p>
      </blockquote>
    </Menu>
    <p>{`Enter `}<strong parentName="p">{`Tropu'hopu`}</strong>{`. Warp `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you didn't get enough JP for Evasive Maneuvers, you can buy a Wind M from man north of Tropu'hopu entrance, and kill something on the way to Clockbank.`}</p>
    </blockquote>
    <h3 {...{
      "id": "walk-to-clockbank"
    }}>{`Walk to Clockbank`}</h3>
    <p><strong parentName="p">{`New Delsta Anchorage`}</strong>{`: Walk at end of steps near exit`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Eastern New Delsta Highroad`}</strong>{`: Run after boat tutorial`}</p>
    <blockquote>
      <p parentName="blockquote">{`With EM on, running on land subtracts 2 more from the step counter. "Running" on the boat only subtracts 1 more from the step counter. So on screen with both land and water where you walk part of it, you want to walk the part on land.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Western Clockbank Highroad`}</strong>{`: Run whole screen.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Southern Clockbank Highroad`}</strong>{`: Walk whole screen. Pick `}<strong parentName="p">{`$6300`}</strong>{`. Enter `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <h3 {...{
      "id": "clockbank-partitio-ch2"
    }}>{`Clockbank (Partitio Ch.2)`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Fire M, Wind M`}</strong>{` from Old Woman to the right.`}<br parentName="p"></br>{`
`}{`Allure `}<strong parentName="p">{`Haggard Man`}</strong>{` on the left for the Cat Quest.`}</p>
    <p>{`Go to next screen, go left to trigger cutscene.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Shadow M`}</strong>{` from Father by factory. Continue story triggers.`}<br parentName="p"></br>{`
`}{`Before getting Clockite, buy `}<strong parentName="p">{`Thunder M`}</strong>{` from man by Weapon Shop.`}<br parentName="p"></br>{`
`}{`Turn in `}<strong parentName="p">{`Clockite`}</strong>{`, then head to the west side of 2nd screen.`}</p>
    <p>{`Talk to `}<strong parentName="p">{`Lonesome Cat`}</strong>{` in top left corner to complete `}<strong parentName="p">{`My Beloved Catharine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Thief Guild`}</strong>{`, pick `}<strong parentName="p">{`Healing Grape Bunch`}</strong>{` on the way.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Thief License`}</strong>{`. Entreat `}<strong parentName="p">{`Gold Pocket Watch, Dazzling Artwork`}</strong>{` from boy in Thief Guild.`}</p>
    <p>{`Warp `}<strong parentName="p">{`Oresrush`}</strong></p>
    <h3 {...{
      "id": "oresrush-1"
    }}>{`Oresrush`}</h3>
    <p>{`Go towards `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Southern Cropdale Train`}</strong>{`: Walk whole screen to avoid battle.`}</p>
    <h3 {...{
      "id": "northern-wellgrove-trail"
    }}>{`Northern Wellgrove Trail`}</h3>
    <p>{`Go towards `}<strong parentName="p">{`Wind M`}</strong>{` in bottom right of screen. Switch to night a little before you get it. Pick `}<strong parentName="p">{`Wind M`}</strong>{`. Clear battle with 2 Wind M. After clearing the battle, switch back to day and go to `}<strong parentName="p">{`Eastern Wellgrove Trail`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Optionally pick a `}<strong parentName="p">{`Pom L`}</strong>{` north of the sign.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`The `}<strong parentName="p">{`Demon Deer`}</strong>{` in both battles seems to do bigger attacks when it's lower HP. For the fight where you use Shadow M, if it's going to get an action off try to use the Shadow M after it gets it's action.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Take note of Partitio's Latent after the 2nd battle.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Eastern Wellgrove Trail`}</strong>{`: Pick `}<strong parentName="p">{`Magus Knife`}</strong>{` in top left corner. Kill battle with `}<strong parentName="p">{`Shadow M + boosted ability on Demon Deer.`}</strong>{` Take right path, enter Wellgrove`}</p>
    <h3 {...{
      "id": "wellgrove"
    }}>{`Wellgrove`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Pocket Watch`}</li>
        <li parentName="ul">{`Dazzling Artwork`}</li>
        <li parentName="ul">{`Magus Knife`}</li>
        <li parentName="ul">{`Cait Powder `}<em parentName="li">{`L1 x1/2 to select. x2 if you have Conoct ingredients`}</em>{`.`}</li>
      </ul>
    </Menu>
    <p>{`Warp `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tropuhopu"
    }}>{`Tropu'hopu`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Marksman's Bow, Pretty Pearl, Light Nut L`}</strong>{` from Beastling by entrance. Go north to next screen.`}<br parentName="p"></br>{`
`}{`Entreat `}<strong parentName="p">{`Pom S, Gorgeous Sari, Empowering Bracelet`}</strong>{` from Artisan Lady.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If Partitio needs Lychees for Latent, can delay this menu.`}</p>
      </blockquote>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Empowering Bracelet: Osvald`}</li>
        <li parentName="ul">{`Gorgeous Sari: Partitio`}</li>
        <li parentName="ul">{`Light L: Partitio`}</li>
      </ul>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Thief, +Armor Corrosive`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Man Searching for Pearls at bottom left to complete `}<strong parentName="p">{`Pearl Hunt`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <h3 {...{
      "id": "clockbank"
    }}>{`Clockbank`}</h3>
    <p>{`Go to Tavern, Hire story guy. Go to Factory. Go to Factory again.`}<br parentName="p"></br>{`
`}{`Kill battle with `}<strong parentName="p">{`Thunder M`}</strong>{`. Pick `}<strong parentName="p">{`Lychee M`}</strong>{` to the right before door if needed.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you don't have full Latent, get it.`}<br parentName="p"></br>{`
`}{`If you do, it's optional. Can be used instead of the Lychee L in Ch.4, but sometimes it won't be needed.`}</p>
    </blockquote>
    <p>{`Kill battle with `}<strong parentName="p">{`Fire M`}</strong>{`. Pick `}<strong parentName="p">{`$7000`}</strong>{`. If ambushed and need healing, healing before Garnet.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "garnet-23000hp-spear-axe-fire-lightning"
      }}>{`Garnet 23000HP Spear, Axe, Fire, Lightning`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: LATENT Collect x4`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Defend`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Armor Corrosive x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: If alive, Healing Grape (Bunch) if anyone is 500HP or less.`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Defend`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Fireball`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x4`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Poison Axe if Garnet survived (should never happen)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Partitio should be full Latent after this fight`}</p>
      </blockquote>
    </Battle>
    <h3 {...{
      "id": "tropuhopu-1"
    }}>{`Tropu'hopu`}</h3>
    <p>{`Purchase Boat.`}</p>
    <h3 {...{
      "id": "sea"
    }}>{`Sea`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Reinforcing Jam, $20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Crackridge Anchorage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat, pick `}<strong parentName="p">{`Sunken Golden Statue`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-partitio-ch3"
    }}>{`Wellgrove (Partitio Ch.3)`}</h3>
    <blockquote>
      <p parentName="blockquote">{`There are a lot of optional options here, depending on how much time you want to sacrifice for safety on last 2 bosses. The core notes will skip everything that's not necessary, but will denote any optional options in blocks like this. The money routes for some of these variations can be very tight, so if you used any extra you could end up short.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`You can optionally get `}<strong parentName="p">{`Dancer Guild`}</strong>{`. If you do, give it to Castti before Thurston and teach her Stimulate.`}</p>
    </blockquote>
    <p>{`Continue the story until the Hiring segment.`}<br parentName="p"></br>{`
`}{`Hire Merchant in the top left, then Merchant in the tavern. Then go to the `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sunken Golden Statue`}</li>
        <li parentName="ul">{`Marksman's Bow`}</li>
        <li parentName="ul">{`Cupid's Bow`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Remove Empowering Bracelet`}</li>
        <li parentName="ul">{`Partitio: Equip Empowering Bracelet`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal Partitio, Agnea if she's dead.`}</p>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Sidestep`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Boost Start`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Optionally Hire right soldier for `}<strong parentName="p">{`Chivalry`}</strong>{`.`}</p>
    </blockquote>
    <p>{`Hire 3rd Merchant, do story Purchases, go to Thurston.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`This fight can be done using either $30000 or $45000. Your ability to buy Bracelets will change based on the amount used here. For fastest route, feel free to use $45000 here to save time, as you won't be buying Bracelets anyway.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`There are a lot of different potential Thurston fights, I will try to cover more possible scenarios in the Addendum. Will list only basic ones here.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`2 biggest goals in this fight are to get Partitio before the Steam Engine, and to break Thurston before his next turn. If you don't succeed, you will probably lose.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`Thurston can open with a multitude of different attacks. Modify and Flammable Oil are freebies (assuming you can kill the Engine, the rest require adjustment / are losses (Throw Wrench).`}</p>
      </blockquote>
      <h4 {...{
        "id": "thurston-35000hp-sword-axe-bow-ice-wind"
      }}>{`Thurston 35000HP Sword, Axe, Bow, Ice, Wind`}</h4>
      <h6 {...{
        "id": "steam-engine-7500hp-spear-dagger-fire-lightning"
      }}>{`Steam Engine 7500HP Spear, Dagger, Fire, Lightning`}</h6>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x3 (HHV x3 if Reinforce)`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: If before Partitio & Partitio is after Steam Engine, Stimulate Partitio. Else, Defend`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: If before Partitio can Armor Corrosive Engine if it got Reinforced, else Defend. If after Partitio, Sword x2 or AC.`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Before Partitio Defend, After can Attack x2, or Defend.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Goal of this turn is to break before Tank gets a turn.`}<br parentName="p"></br>{`
`}{`HHB x4 on broken Thurston is a range (if you miss all 4 crits you don't kill.) You can try to cover this with Castti Poison Axe.`}<br parentName="p"></br>{`
`}{`HHV x4 on unbroken Thurston with AC is also a range.`}<br parentName="p"></br>{`
`}{`HHV x4 on broken Thurston kills without AC.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Stimulate if needed / Ruinous Kick if needed / Defend.`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: LATENT HHB x4 / HHV x4. If he needs to break, can do Bow x3/4 or HHM x3/4. Else Defend.`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Sword Attacks / AC`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attacks`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Kill him with Partitio. If AC is needed and not applied, can Stimulate Osvald with Agnea to put him before Partitio.`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: If doing HHB x4, Poison Axe`}</li>
      </ul>
      <h4 {...{
        "id": "sample-fight"
      }}>{`Sample Fight`}</h4>
      <p><em parentName="p">{`We'll assume turn order is Agnea, Engine, Castti, Partitio, Osvald. Assume Thurston did something harmless. And we're trying to save money for Bracelets.`}</em></p>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Stimulate x2 Partitio`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x3`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Sword x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If not trying to save money, can just have Castti do Axe x2 and have Partitio do HHV x4 T2.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attack x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Armor Corrosive`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x4 if after Osvald, else Defend.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x4 if you defended`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Poison Axe x2 if still alive`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "wellgrove-1"
    }}>{`Wellgrove`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If trying to play safer, can enter Department Store and buy Empowering Bracelets from bottom floor top right merchant.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`With Chivalry: Can buy 4 if you used $45000 on Thurston. Can 5 if you used $30000, 6 if you get a little bit more money. Need `}<strong parentName="p">{`$26500`}</strong>{` when done with shop.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Without Chivalry: Can buy 3 if you used $30000 on Thurston. Need `}<strong parentName="p">{`$42000`}</strong>{` when done with shop.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you have no Lychee's, and Partitio is 0 Latent, consider buying the Lychee M from girl between Tavern and Inn. Costs $1000. If you don't break anything in Roque Factory, you will be short for Latent even with the Lychee L.`}</p>
    </blockquote>
    <p>{`Warp `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`, go to `}<strong parentName="p">{`Roque Island`}</strong>{`.`}</p>
    <h3 {...{
      "id": "roque-anchorage"
    }}>{`Roque Anchorage`}</h3>
    <p>{`Switch to Night at start of steps, kill night battle with `}<strong parentName="p">{`HHB x3`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Walk rest in day.`}</p>
    <h3 {...{
      "id": "roque-island-partitio-ch4"
    }}>{`Roque Island (Partitio Ch.4)`}</h3>
    <p>{`Go north for story trigger. Go to Tavern for story trigger.`}<br parentName="p"></br>{`
`}{`Switch to night before entering Factory.`}</p>
    <h3 {...{
      "id": "roque-factory"
    }}>{`Roque Factory`}</h3>
    <p>{`Kill battle with HHB x3. Take note of Partitio's JP (Want 1000). Switch back to day.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Whether or not you have enough depends heavily on what battle you get here. There's a 30% chance to get a group of 2, in which case you will likely be short.`}</p>
    </blockquote>
    <p>{`If needed, pick `}<strong parentName="p">{`Lychee L`}</strong>{`. If you have 50% Latent and a Lychee M, it isn't necessary.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Ember `}<em parentName="li">{`If possible`}</em></li>
        <li parentName="ul">{`Castti: +2 Apothecary Skills, Thief, +Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Hang Tough `}<em parentName="li">{`If possible`}</em></li>
        <li parentName="ul">{`Castti: +Hale & Hearty`}</li>
      </ul>
    </Menu>
    <p>{`Travel Banter on second Ladder going down.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Fire L`}</strong>{`.`}</p>
    <p>{`You will want to walk a lot of the 2nd Factory Screen to avoid battles.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$24500`}</strong>{`. Travel Banter to reset steps.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Note that you will likely die here, a lot. Bracelets help but still do not guarantee a win.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`An important mechanic for this fight is the "Repair Counter". As soon as you kill a part, every Steam Tank turn advances the repair counter by 1. Once the counter is at 5, he will start repairing the other parts of the train. This is actually good for us, as he won't be attacking you. With most fights, you won't be able to kill before repairs start, so you'll be taking advantage of repairs to setup the kill.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The only threatening repair is the bottom one, which will use Drive Away. Drive Away goes through Sidestep, and removes a character from the fight. However, it will prioritize everyone else over Partitio, so you can Olive someone to tank it for you. The other 2 parts are harmless for their first action.`}</p>
      </blockquote>
      <h4 {...{
        "id": "steam-tank-70000hp-spear-bow-shadow"
      }}>{`Steam Tank 70000HP Spear, Bow, Shadow`}</h4>
      <blockquote>
        <p parentName="blockquote">{`We assume that at most only Partitio & Castti are alive going into turn 2, generally just Partitio.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Paritio`}</strong>{`: If first LATENT HHV x4. If at end and dies to next hit, Sidestep x3`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea/Osvald/Castti`}</strong>{`: Fire L`}</li>
        <li parentName="ul">{`If anyone else has a spare turn, can heal. If it's Castti, can Defend > Armor Corrosive x3`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Assuming only Partitio survived, and Partitio was first. Also assuming all parts are dead.`}<br parentName="p"></br>{`
`}{`This is more of a worst case fight, can speed this up if fight is good. Can also Olive L Castti at Counter 5 so she's very likely to get Armor Corrosive off. Downside is that with no Bracelets she can get single target crit and die.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-counter-2"
      }}>{`Turn 2 (Counter: 2)`}</h5>
      <ul>
        <li parentName="ul">{`Sidestep x3 (Latent HHV x4 if you did Sidestep 1st turn)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-repair-counter-3"
      }}>{`Turn 3 (Repair Counter: 3)`}</h5>
      <ul>
        <li parentName="ul">{`Reinforcing Jam`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-counter-4"
      }}>{`Turn 4 (Counter: 4)`}</h5>
      <ul>
        <li parentName="ul">{`Sidestep x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5-counter-5"
      }}>{`Turn 5 (Counter: 5)`}</h5>
      <ul>
        <li parentName="ul">{`Collect x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6-repair-1"
      }}>{`Turn 6 (Repair 1)`}</h5>
      <ul>
        <li parentName="ul">{`Olive Castti`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7-repair-2"
      }}>{`Turn 7 (Repair 2)`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`If Castti gets a turn, AC x2 Tank, skip Ruffians part of script. Assuming she doesn't get a turn.`}</em></li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHR x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8-repair-3"
      }}>{`Turn 8 (Repair 3)`}</h5>
      <ul>
        <li parentName="ul">{`LATENT HHV x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`HHV x3 / Defend and HHV x4 next turn.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`HHV x3 can fail sometimes. If short money, can also finish with HHB x4, but not sure how consistent it is.`}</p>
      </blockquote>
    </Battle>
    <p>{`Hire `}<strong parentName="p">{`Roque`}</strong>{`, skip cutscenes, end timer at Credit Screen. GG!`}</p>
    <h2 {...{
      "id": "addendum"
    }}>{`Addendum`}</h2>
    <h3 {...{
      "id": "caits-and-puffs"
    }}>{`Caits and Puffs`}</h3>
    <p>{`These all assume you're not buying Bracelets. If anyone wants to work out the Bracelet differences and have me add them here, let me know.`}</p>
    <p>{`Not listed below are the obvious changes that come from extra EXP / JP, such as guaranteeing Hang Tough and being less likely to die to random battles, etc.`}</p>
    <h4 {...{
      "id": "cait"
    }}>{`Cait`}</h4>
    <p>{`There are 2 timings for this, before and after Osvald. If before, I'm not sure it's worth killing. But if you decide to, after Osvald you will want to warp Crackridge Harbor and purchase the Ice M there.`}</p>
    <p>{`Assuming you get a Cait on the way to Tropu'hopu (and skip the next Tropu'hopu battle), here is what changes.`}</p>
    <h5 {...{
      "id": "changes"
    }}>{`Changes`}</h5>
    <ul>
      <li parentName="ul">{`Entreat all the stuff in Tropu'hopu right away.`}</li>
      <li parentName="ul">{`Can skip Magus Knife chest.`}</li>
      <li parentName="ul">{`Garnet: Agnea can't die anymore. Osvald still needs Bracelet, barely can't tank a Bite with Gorgeous Sari. Castti should be safe now.`}</li>
      <li parentName="ul">{`Garnet: Partitio will barely not refill full latent from Garnet Soulstone + Break. Unless he got latent from T1, will need to use a Lychee before Thurston.`}</li>
      <li parentName="ul">{`Thurston: Can probably teach Castti Hale & Hearty. Castti can tank 1 Wrench (maybe 2 if full HP?).`}</li>
      <li parentName="ul">{`If you picked up the Magus Knife and only used $30000 on Thurston, you should barely be able to skip the $24500 chest.`}</li>
    </ul>
    <h4 {...{
      "id": "puff"
    }}>{`Puff`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Gives $1500, 500XP, 300JP`}</p>
    </blockquote>
    <h5 {...{
      "id": "changes-1"
    }}>{`Changes`}</h5>
    <ul>
      <li parentName="ul">{`Entreat all the stuff in Tropu'hopu right away.`}</li>
      <li parentName="ul">{`Can skip Magus Knife`}</li>
      <li parentName="ul">{`Can teach Boost Start + Hale & Hearty before Garnet`}</li>
      <li parentName="ul">{`Garnet: Agnea barely can't tank Bite still. Castti can tank it even without healing Hale & Hearty HP.`}</li>
    </ul>
    <h4 {...{
      "id": "cultured-cait"
    }}>{`Cultured Cait`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Gives $10000, 1250XP, 400JP`}</p>
    </blockquote>
    <h5 {...{
      "id": "changes-2"
    }}>{`Changes`}</h5>
    <ul>
      <li parentName="ul">{`Can skip both Magus Knife & $7000 in Ch.2. In test save had $101700 after Garnet.`}</li>
      <li parentName="ul">{`Can teach Boost Start + Hale & Hearty before Garnet. No need to heal Castti.`}</li>
      <li parentName="ul">{`Garnet: Once again, Partitio won't fill Latent unless he gets hit T1`}</li>
      <li parentName="ul">{`Garnet: Osvald can tank a Bite (unless 2.5% crit). So no need for Bracelet, can just go on Partitio. It doesn't change Latent thresholds for Partitio either, he will either get Latent or need a Lychee M regardless.`}</li>
      <li parentName="ul">{`You don't level off Garnet, so will need want to heal before Thurston. Maybe just heal Partitio & Castti? Don't know if Agnea can tank anything, might be close.`}</li>
    </ul>
    <h4 {...{
      "id": "queen-puff"
    }}>{`Queen Puff`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Gives $3000, 500XP, 750JP`}</p>
    </blockquote>
    <h5 {...{
      "id": "changes-3"
    }}>{`Changes`}</h5>
    <ul>
      <li parentName="ul">{`Can skip Magus Knife (barely).`}</li>
      <li parentName="ul">{`Can teach Boost Start + Hale & Hearty right after kill.`}</li>
      <li parentName="ul">{`Garnet: Damage ranges & Latent management are the same as normal puff.`}</li>
    </ul>
    <h4 {...{
      "id": "chubby-cait"
    }}>{`Chubby Cait`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Gives $50000, 2000XP, 1000JP. Kill with HHV x3`}</p>
    </blockquote>
    <h5 {...{
      "id": "changes-4"
    }}>{`Changes`}</h5>
    <ul>
      <li parentName="ul">{`Can skip $24500 Chest.`}</li>
      <li parentName="ul">{`Don't know how much it helps on Train.`}</li>
    </ul>
    <h4 {...{
      "id": "king-puff"
    }}>{`King Puff`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Gives $25000, 1000XP, 1500JP. Kill with ???`}</p>
    </blockquote>
    <h5 {...{
      "id": "changes-5"
    }}>{`Changes`}</h5>
    <p>{`If killed with HHB x3 can skip $24500.`}</p>
    <h3 {...{
      "id": "garnet"
    }}>{`Garnet`}</h3>
    <h4 {...{
      "id": "elemental-barrage-script"
    }}>{`Elemental Barrage script`}</h4>
    <p>{`Here's an alternate script YTreds made. I choose not to use it because Elemental Barrage can hit the same element with every hit, so it's possible to just get Ice and fail the fight. But the odds are exceedingly low, so it's worth putting in here. Can maybe be used as a backup to Castti getting hit by a crit Bite.`}</p>
    <p>{`Below is copy and pasted from discord :)`}</p>
    <Battle mdxType="Battle"> 
      <p>{`My Elemental Barrage strat in Garnet battle is below.`}<br parentName="p"></br>{`
`}{`Unless very bad luck Elemental Barrage, Garnet shields will be reduced to 3 or less.`}<br parentName="p"></br>{`
`}{`If Castti Bite crit, to break Garnet.`}</p>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Latent Collect X4`}</li>
        <li parentName="ul">{`Agnea: Defend or if Castti Bite crit, Ruinous Kick`}</li>
        <li parentName="ul">{`Osvald(HP+500): Elemental Barrage x2 (x1 if Castti Bite crit)`}</li>
        <li parentName="ul">{`Castti(Thief): Attack x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: If alive, heal(Healing Grape Bunch) or Ruinous Kick (or Attack)`}</li>
        <li parentName="ul">{`Partitio: Defend or Attack`}</li>
        <li parentName="ul">{`Osvald: Fireball or Elemental Barrage x1(or2) (or Attack)`}</li>
        <li parentName="ul">{`Castti: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
      <p>{`If very good luck Elemental Barrage and good T2 order, break Garnet and Armor Corrosive > HHB x3 (however not refill latent power in the battle)`}</p>
    </Battle>
    <h4 {...{
      "id": "osvald-death-script"
    }}>{`Osvald Death Script`}</h4>
    <p>{`If you decide to greed and not give Osvald a Bracelet, and only Osvald dies T1 to Bite (before he gets his action), here's a backup. If it's after his action, can just have Agnea Ruinous Kick T2. Note that Partitio won't get to break to fill Latent.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "garnet-23000hp-spear-axe-fire-lightning-1"
      }}>{`Garnet 23000HP Spear, Axe, Fire, Lightning`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: LATENT Collect x4`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Defend`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Dead`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Ruinous Kick`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Attack x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Attack x4`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Olive Osvald`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Agnea`}</strong>{`: Stimulate Osvald`}</li>
        <li parentName="ul"><strong parentName="li">{`Osvald`}</strong>{`: Armor Corrosive`}</li>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHB x3`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "thurston"
    }}>{`Thurston`}</h3>
    <p>{`There are a lot of variations to this fight, so I want to go over some general kill patterns / scenarios.`}</p>
    <h4 {...{
      "id": "general-thurston-kills"
    }}>{`General Thurston Kills`}</h4>
    <ul>
      <li parentName="ul">{`HHB x4 (Break) > Armor Corrosive > HHB x3`}</li>
      <li parentName="ul">{`HHB x4 (Break) > Pom S > HHB x4`}</li>
      <li parentName="ul">{`Break > HHV x4`}</li>
      <li parentName="ul">{`Break > Armor Corrosive > HHB x4 (If no crits, can be short 400-800, try to finish with Poison Axe)`}</li>
      <li parentName="ul">{`No Break > AC > HHV x4 (No idea what this range is)`}</li>
    </ul>
    <h4 {...{
      "id": "scenarios"
    }}>{`Scenarios`}</h4>
    <h5 {...{
      "id": "thurston-attacks--kills-osvald"
    }}>{`Thurston attacks & kills Osvald`}</h5>
    <p>{`If you also had Agnea Stimulate T1, you will need someone before Thurston T2 to win. Else, you can have Agnea Defend, Castti Defend, Ruinous Kick + Attack x3 to break, and Latent HHR x2 into HHB x4 next turn. Anyone else dying should be simpler to recover than Osvald dying.`}</p>
    <h5 {...{
      "id": "thurston-reinforces-the-engine"
    }}>{`Thurston Reinforces the Engine`}</h5>
    <p>{`T1 Partitio HHV x3, then you break, apply AC, and go for HHB x4`}</p>
    <h5 {...{
      "id": "engine-gets-a-turn-does-blind-move"
    }}>{`Engine gets a turn, does blind move`}</h5>
    <p>{`Can't trust Attacks to knock off shields anymore, so try to break with Partitio HHM x4 or HHB x4.`}</p>
    <h5 {...{
      "id": "thurston-does-throw-wrench"
    }}>{`Thurston does Throw Wrench`}</h5>
    <p>{`Just die :)`}</p>
    <h5 {...{
      "id": "sticky-flower"
    }}>{`Sticky Flower`}</h5>
    <p>{`In rare cases, you can use a Sticky Flower (drop from Tropu'hopu battles) conoct to either fix turn order, or guarantee(?) crits for Beastlings. Be mindful of when you use it though, as it only lasts one turn. If Castti has Latent can use that to get multiple casts in 1 turn.`}</p>
    <h4 {...{
      "id": "money"
    }}>{`Money`}</h4>
    <p>{`If you aren't buying Bracelets and you skip the $24500 chest, you are about 2.2k short for the 3rd Vets on Train (Assuming 1 Ruffians). Can probably skip the chest with a Cait.`}</p>
    <h3 {...{
      "id": "steam-tank"
    }}>{`Steam Tank`}</h3>
    <p>{`The fight in the notes is the worst case / slow fight. But it can be sped up, and can even kill before repairs start. Here's an example fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "steam-tank-1"
      }}>{`Steam Tank`}</h4>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: LATENT HHV x4`}</li>
        <li parentName="ul"><strong parentName="li">{`Agnea/Osvald`}</strong>{`: Fire L`}</li>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Castti`}</strong>{`: Armor Corrosive x3`}</li>
        <li parentName="ul"><strong parentName="li">{`Paritio`}</strong>{`: Sidestep x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Reinforcing Jam`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Collect x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: Latent HHV x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Partitio`}</strong>{`: HHV x3`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h3 {...{
      "id": "22324"
    }}>{`2/23/24`}</h3>
    <ul>
      <li parentName="ul">{`Properly remove Cape Cold from the notes (sorry Sanjan LOL)`}</li>
      <li parentName="ul">{`Add text to recruit Agnea`}</li>
    </ul>
    <h3 {...{
      "id": "2924"
    }}>{`2/9/24`}</h3>
    <ul>
      <li parentName="ul">{`Added Cait/Puff notes to addendum`}</li>
      <li parentName="ul">{`Added Osvald death backup to addendum`}</li>
      <li parentName="ul">{`Added backup for being short for EM`}</li>
    </ul>
    <h3 {...{
      "id": "2824"
    }}>{`2/8/24`}</h3>
    <ul>
      <li parentName="ul">{`Initial upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      